import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import { Row, Col, Alert, Modal } from "react-bootstrap";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import accountManagement from "../../../../../apis/accountManagement";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import akmApi from "../../../../../apis/akmApi";
import Select from "react-select";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";

class ImportProdi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      resMessage: "",
      alertShow: false,
      isFetching: false,
      openModal: false,
      listProvinsi: [],
      idProvinsi: null,
      namaPtn: null,
      typeUpload: null,
    };
  }

  async componentDidMount() {
    console.clear();
    await this.props.cekCookies();
    if (!__.isEmpty(this.props.account)) {
      this.fetchProvinsi();
    }
  }

  fetchProvinsi = async () => {
    this.setState({ isFetching: true });
    const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {});
    if (respons) {
      if (!__.isEmpty(respons.data.list_provinsi)) {
        // this.setState({
        //     provinsi: respons.data.list_provinsi
        // })
        const dataProvinsi = { value: "", label: "Pilih Provinsi...", id: "idProvinsi", selected: "selected" };
        this.state.listProvinsi.push(dataProvinsi);
        respons.data.list_provinsi.map((val, i) => {
          const dataProvinsi = { value: val.ID_PROVINSI, label: val.NAMA_PROVINSI, id: "idProvinsi" };
          this.state.listProvinsi.push(dataProvinsi);
        });
      }
    }
    this.setState({ isFetching: false });
  };

  onFileChange = (event) => {
    this.setState({
      file: event.target.files[0],
    });
  };

  handleChangeSelect = async (e) => {
    const name = e.id;
    const id = e.value;
    this.setState({
      [e.id]: id,
    });
  };

  handleChange = async (e) => {
    const name = e.target.name;
    const id = e.target.value;
    this.setState({
      [name]: id,
    });
  };

  componentDidUpdate() {
    // console.clear();
    // console.log(this.state);
  }

  handleSubmit = async (event) => {
    this.setState({ isFetching: true });

    event.preventDefault();
    if (this.state.file != "" && this.state.file.size < 1000000) {
      let data = new FormData();
      data.append("file", this.state.file);
      const response = await akmApi.post(URL_AKM.IMPORT_PRODI_SBMPTN + this.state.typeUpload, data).catch(function (error) {
        this.setState({ error });
      });

      console.log(response);
      if (response) {
        this.setState({
          resMessage: response.data.errorSchema,
          isFetching: false,
          alertShow: true,
          dataUser: response.data.data.dataUser,
          keterangan: response.data.data.keterangan,
        });
        document.getElementById("file").value = "";
      }
    } else {
      this.setState({
        resMessage: "File Dokumen harus < 1Mb ..!!",
        alertShow: true,
        isFetching: false,
      });
    }
  };

  render() {
    const { isFetching, listProvinsi, idProvinsi, typeUpload } = this.state;
    return (
      <div className="wrapper">
        <LoaderModal isFetching={isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar />
          <div className="row">
            <div className="col-md-12">
              <h4>UPLOAD PROGRAM STUDI</h4>
            </div>
          </div>
          {this.loadAlert()}
          {this.renderModalPtn()}
          <div className="row">
            <div className="col-md-5">
              <div class="card">
                <div class="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label>
                        <span className="text-danger">*</span>Type Upload
                      </label>
                      <RadioGroup aria-label="typeUpload" name="typeUpload" value={typeUpload} onChange={this.handleChange} required>
                        <FormControlLabel id="SNMPTN" value="SNMPTN" control={<Radio />} label="SNMPTN" />
                        <FormControlLabel id="SBMPTN" value="SBMPTN" control={<Radio />} label="SBMPTN" />
                      </RadioGroup>
                    </div>
                    <div className="form-group">
                      <label>
                        <span className="text-danger">*</span>Pilih File:{" "}
                      </label>
                      <input type="file" className="form-control" required onChange={this.onFileChange} id="file" accept=".xlsx" />
                    </div>
                    <br />
                    <button type="submit" value="Submit" className="btn btn-primary">
                      <li className="fa fa-upload"> Upload</li>
                    </button>
                    <button type="button" className="btn btn-outline-info pull-right">
                      <li className="fa fa-plus" onClick={() => this.handleModal(true)}>
                        {" "}
                        PTN
                      </li>
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div class="card">
                <div class="card-body">
                  <h5>Prosedur Upload Prodi :</h5>
                  <ol>
                    <li>Download format dokumen (.xlsx)&nbsp;</li>
                    <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                    <li>
                      Format dokumen wajib&nbsp;
                      <span class="text-danger">
                        <strong>*</strong>
                      </span>
                      <strong>.xlsx</strong>
                      <span class="text-danger">
                        <strong>*</strong>
                      </span>
                    </li>
                    <li>
                      Prodi Akan di update berdasarkan <strong>KODE PRODI</strong> yang telah tersedia di system,
                    </li>
                    <li>KODE PRODI di sistem yang tidak sesuai dengan file upload akan otomatis terhapus</li>
                    <li>PASTIKAN file yang akan di upload sudah sesuai dengan data terbaru.</li>
                    <br />
                    <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + "/UPDATE_SBMPTN_2021.xlsx"}>
                      <li className="fa fa-download"> Download</li>
                    </a>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleModal(newPtn) {
    this.setState({ openModal: newPtn });
  }

  renderModalPtn() {
    const { listProvinsi, idProvinsi, namaPtn, regional } = this.state;
    return (
      <Modal show={this.state.openModal} onHide={() => this.setState({ openModal: false })} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Add PTN</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.handleSubmitAddPtn}>
            <Row>
              <Col>
                <Fragment>
                  <Select options={listProvinsi} onChange={this.handleChangeSelect} placeholder="Pilih Provinsi..." />
                  <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={idProvinsi} required />
                </Fragment>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form-group">
                  <label>
                    <span className="text-danger">*</span>Nama Ptn
                  </label>
                  <input type="text" className="form-control" required onChange={this.handleChange} name="namaPtn" id="namaPtn" value={namaPtn} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form-group">
                  <label>
                    <span className="text-danger">*</span>Regional
                  </label>
                  <input type="number" className="form-control" required maxLength="1" min="1" onChange={this.handleChange} name="regional" id="regional" value={regional} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <button type="submit" value="Submit" className="btn btn-primary">
                  <li className="fa fa-save"> save</li>
                </button>
              </Col>
            </Row>
          </form>
        </Modal.Body>
      </Modal>
    );
  }

  handleSubmitAddPtn = async (e) => {
    e.preventDefault();
    this.setState({
      isFetching: true,
      openModal: false,
    });
    let data = new FormData();
    data.append("idProvinsi", this.state.idProvinsi);
    data.append("namaPtn", this.state.namaPtn);
    data.append("regional", this.state.regional);

    const response = await akmApi.post(URL_AKM.ADD_PTN, data).catch(function (error) {
      this.setState({ error });
    });

    if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
      this.setState({
        keterangan: response.data.data.keterangan,
        alertShow: true,
        listKelasParalel: [],
      });
    } else {
      this.setState({
        keterangan: response.data.data.keterangan,
        alertShow: true,
      });
    }
    this.setState({ isFetching: false });
  };

  loadAlert = () => {
    const { alertShow, keterangan } = this.state;

    if (alertShow) {
      return (
        <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
          <strong>{keterangan}</strong>
        </Alert>
      );
    }
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(ImportProdi);
